import { Area, FT_PI_AUTH0_LOGIN } from '@whitbread-eos/api';
import { getAuthCookie } from '../getters/auth';
import useFeatureToggle from './use-feature-toggle';
import { useAuth0AccessToken } from './useAuth0AccessToken';
export function useAuthToken() {
  var _featureToggles$FT_PI;
  var featureToggles = useFeatureToggle();
  var isAuth0Enabled = (_featureToggles$FT_PI = featureToggles === null || featureToggles === void 0 ? void 0 : featureToggles[FT_PI_AUTH0_LOGIN]) !== null && _featureToggles$FT_PI !== void 0 ? _featureToggles$FT_PI : false;
  var _useAuth0AccessToken = useAuth0AccessToken(isAuth0Enabled),
    auth0AccessToken = _useAuth0AccessToken.accessToken,
    isLoading = _useAuth0AccessToken.isLoading;
  var token = isAuth0Enabled && auth0AccessToken ? auth0AccessToken : getAuthCookie();
  return {
    token,
    isAuth0Enabled,
    isLoading: isAuth0Enabled ? isLoading : false
  };
}
export function useLoggedOrCCUI(area) {
  var _useAuthToken = useAuthToken(),
    token = _useAuthToken.token;
  return !!(token || area === Area.CCUI);
}